<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="font-family:Calisto MT; letter-spacing:1px; font-size:18pt; padding-top:70px; padding-bottom:20px;">Dedication</h1>
<p style="text-align: center;">This book is dedicated to all those who have tried to lose weight!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?563391e0